import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "up",
  "use": "up-usage",
  "viewBox": "0 0 90 90",
  "content": "<symbol fill=\"currentColor\" viewBox=\"0 0 90 90\" id=\"up\">\n  <path fill=\"#000\" fill-rule=\"evenodd\" d=\"M41.613 80V13.365h4.774V80h-4.774Z\" clip-rule=\"evenodd\" />\n  <path fill=\"#000\" fill-rule=\"evenodd\" d=\"m70 35.925-3.375 3.366L44 16.73 21.375 39.29 18 35.925 44 10l26 25.925Z\" clip-rule=\"evenodd\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol